'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import ConsentPreferenceCenter from './ConsentPreferenceCenter';

export default function Footer() {
  const [showPreferences, setShowPreferences] = useState(false);

  return (
    <>
      <footer className="border-t" style={{ borderColor: 'var(--border)', backgroundColor: 'var(--background)' }}>
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-12 md:py-16">
          {/* Top Row */}
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 md:gap-10">
            {/* Brand */}
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <div className="flex items-center rounded-sm">
                  <img
                    alt="Logo"
                    width={36}
                    height={36}
                    src="https://buchhaltungaktas-4lh9a97.public.builtwithrocket.new/_next/image?url=%2Fassets%2Fimages%2FAktas_3-1785851522351.png&w=96&q=85"
                    className="flex-shrink-0"
                    style={{ color: 'transparent' }} />
                  
                </div>
                <div className="flex flex-col leading-none">
                  <span className="font-display font-semibold text-sm tracking-wide" style={{ color: 'var(--foreground)' }}>Sulleyman Aktas</span>
                  <span className="text-xs font-medium tracking-wider uppercase" style={{ color: 'var(--muted-foreground)' }}>Buchhaltungsbüro</span>
                </div>
              </div>
              <p className="text-sm max-w-xs leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
                Persönliche Buchhaltung für Ihren unternehmerischen Erfolg.
              </p>
            </div>

            {/* Nav Links */}
            <div className="flex flex-wrap gap-x-10 gap-y-2">
              <div className="flex flex-col gap-1">
                {[{ href: '#leistungen', label: 'Leistungen' }, { href: '#ueber-uns', label: 'Über uns' }, { href: '#kontakt', label: 'Kontakt' }]?.map((link) =>
                  <a
                    key={link?.href}
                    href={link?.href}
                    onClick={(e) => { e?.preventDefault(); document.querySelector(link?.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                    className="text-sm font-medium transition-colors py-2 min-h-[44px] flex items-center"
                    style={{ color: 'var(--muted-foreground)' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = 'var(--foreground)'}
                    onMouseLeave={(e) => e.currentTarget.style.color = 'var(--muted-foreground)'}
                  >
                    {link?.label}
                  </a>
                )}
              </div>
            </div>
          </div>

          {/* Partner Logos */}
          <div className="mt-10 pt-8 border-t flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10" style={{ borderColor: 'var(--border)' }}>
            <p className="text-xs font-medium uppercase tracking-wider" style={{ color: 'var(--muted-foreground)' }}>Mitglied &amp; Partner</p>
            <div className="flex items-center gap-8 flex-wrap justify-center">
              <a href="https://bbh.de/" target="_blank" rel="noopener noreferrer">
                <img
                  src="/assets/images/image-1786103259681.png"
                  alt="b.b.h. – Bundesverband selbstständiger Buchhalter und Bilanzbuchhalter"
                  className="h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
                />
              </a>
              <a href="https://www.wolterskluwer.com/" target="_blank" rel="noopener noreferrer">
                <img
                  src="/assets/images/image-1786103265892.png"
                  alt="Wolters Kluwer"
                  className="h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
                />
              </a>
            </div>
          </div>

          {/* Bottom Row */}
          <div className="mt-10 pt-6 border-t flex flex-col sm:flex-row items-center justify-between gap-4" style={{ borderColor: 'var(--border)' }}>
            <p className="text-sm text-center sm:text-left" style={{ color: 'var(--muted-foreground)' }}>
              © 2026 Buchhaltungsbüro Aktas – Sulleyman Aktas. Alle Rechte vorbehalten.
            </p>
            <div className="flex items-center gap-4 sm:gap-6 flex-wrap justify-center">
              <Link
                href="/privacy"
                className="text-sm transition-colors py-2 min-h-[44px] flex items-center"
                style={{ color: 'var(--muted-foreground)' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--foreground)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--muted-foreground)')}
              >
                Datenschutz
              </Link>
              <Link
                href="/cookies"
                className="text-sm transition-colors py-2 min-h-[44px] flex items-center"
                style={{ color: 'var(--muted-foreground)' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--foreground)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--muted-foreground)')}
              >
                Cookies
              </Link>
              <Link
                href="/impressum"
                className="text-sm transition-colors py-2 min-h-[44px] flex items-center"
                style={{ color: 'var(--muted-foreground)' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--foreground)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--muted-foreground)')}
              >
                Impressum
              </Link>
              <button
                onClick={() => setShowPreferences(true)}
                className="text-sm font-medium transition-colors py-2 min-h-[44px] flex items-center"
                style={{ color: 'var(--muted-foreground)' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--foreground)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--muted-foreground)')}
              >
                Cookie-Einstellungen
              </button>
            </div>
          </div>
        </div>
      </footer>
      {showPreferences && (
        <ConsentPreferenceCenter
          onClose={() => setShowPreferences(false)}
          onSave={() => setShowPreferences(false)}
        />
      )}
    </>
  );
}